import { useArticleSearchCondition } from '@/features/analyze/hooks/useArticleSearchCondition';
import { FacetKey } from '@/features/analyze/types';
import { graphql, useQuery, VariablesOf } from '@/lib/graphql';

const GET_FACETS_QUERY = graphql(`
  query getFacets(
    $condition: ArticleSearchConditionInput!
    $facetKey: ArticleFacetKey!
  ) {
    facets(condition: $condition, facetKey: $facetKey) {
      value
      count
    }
  }
`);

type RequestVariables = VariablesOf<typeof GET_FACETS_QUERY>;

const facetKeyMapping: Record<FacetKey, RequestVariables['facetKey']> = {
  topicTags: 'topic_tags',
  countries: 'country',
  countryTags: 'country_tags',
  organizationTypes: 'organization_type',
  themes: 'themes',
} as const;

type useFacetProps = {
  facetKey: FacetKey;
  sendRequest: boolean;
  ignoreFilterCondition?: boolean;
};

export const useFacet = ({
  facetKey,
  sendRequest = false,
  ignoreFilterCondition = false,
}: useFacetProps) => {
  const filterCondition = useArticleSearchCondition();

  const { data, loading, error } = useQuery(GET_FACETS_QUERY, {
    variables: {
      condition: ignoreFilterCondition ? {} : filterCondition,
      facetKey: facetKeyMapping[facetKey],
    },
    skip: !sendRequest,
    errorPolicy: 'all',
  });

  // エラーハンドリング
  if (error) {
    console.error('Error in useFacet:', error);
  }

  return { facets: data?.facets || [], isLoading: loading };
};
